import { useContext, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import { InsertPPLogs, VerifyAdmin,GetAdminSettingValue } from "../../../api"; //FB 8457
import { Login } from "../../../store/index";
import { UserContext } from "../../../App";  //FB 7874
import useMediaQuery from "@mui/material/useMediaQuery";

// Update log
//
// FB  7469   09/27/2023  SK   Patient Portal - Replace Doctor Direct with License Name , Update logo in Payment Receipt , Change in texts in Home Page
// FB  7874   12/07/2023  DK  Admin should be able to access patient pages
// FB  8457   03/18/2024  GA  Portal-Admin cannot view patient's dashboard

export default function AdminLoginPage() {
  const matches = useMediaQuery("(min-width:600px)");
  const navigate = useNavigate();
  const JSAlert = require("js-alert");
  const context = useContext(UserContext);
  const [open, setOpen] = useState(false);
  const [close, setClose] = useState(false);
  const [loginform, setLoginForm] = useState({
    Username: "",
    Password: "",
    IsGuardian: false,
  } as Login);
  const [errors, setErrors] = useState({ Username: false, Password: false });
  const handleInputChange = (e: any) => {
    setErrors({ ...errors, [e.target.name]: false });
    setLoginForm({ ...loginform, [e.target.name]: e.target.value });
  };
  const validate = () => {
    if (loginform.Username == undefined || loginform.Username === "") {
      setErrors((errors) => ({ ...errors, Username: true }));
      return false;
    }
    if (loginform.Password == undefined || loginform.Password === "") {
      setErrors((errors) => ({ ...errors, Password: true }));
      return false;
    }
    return true;
  };
  const handleLogin = async (e: any) => {
      e.preventDefault();
    //FB 8457 Begin
    let setting = await GetAdminSettingValue("enable_portal_dashboard_options");
    sessionStorage.setItem("enable_portal_dashboard_options",setting);
    //FB 8457 End
    if (validate()) {
      const user = await VerifyAdmin(loginform);
      if (user == 404) {
        JSAlert.alert(
          "Invalid credentials. Please enter a valid username and password.",
          null,
          JSAlert.Icons.Failed
        );
      }
      else if (user.Id > 0) {
        let data = {
          Login: loginform.Username,
          Employee_n: user.Id,
          AdminFirstName: user.EMPLOYEE_FIRST_NAME,
          AdminLastName: user.EMPLOYEE_LAST_NAME,
        };

        sessionStorage.setItem("user", JSON.stringify(data));
        sessionStorage.setItem("is_admin","1");  //FB 7874
        context.setUserLoggedIn(true);  //FB 7874
        navigate("/admin/home/dashboard");
        //InsertPPLogs("Sign In ", window.location.href, loginform.Username, "");
      }
    }
  };

  useEffect(() => {
    if (close) {
      navigate("/user/login");
    }
  }, [close]);

  //FB 7469 - Begin
  const [HeaderText, setHeaderText] = useState("");

  async function LoadHeaderText() {
    let setting = sessionStorage.getItem("LicenseeName");
    if (setting != null) {
      setHeaderText(setting);
    }
  }

  useEffect(() => {
    LoadHeaderText();
  }, []);
  //FB 7469 - End

  return (
    <form onSubmit={handleLogin}>
      <Grid
        container
        spacing={1}
        flexDirection="column"
      //  padding={3}
      >
        <Grid
          item
          xs={12}
          style={{
            backgroundColor: "#F5F5F5",
            minHeight: "75px",
            alignItems: "center",
            display: "flex",
            paddingLeft: matches == false ? "20px" : "90px",
          }}
        >
          <Typography variant="h5" style={{ backgroundColor: "#F5F5F5" }}>
            <b>{HeaderText} Administrator Login</b>{/* FB 7469 */}
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          style={{
            marginLeft: matches == false ? "16px" : "80px",
            marginTop: "15px",
          }}
        >
          <Typography variant="h6">
            <b>Sign in as Admin</b>
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={4}
          style={{
            marginLeft: matches == false ? "16px" : "80px",
            paddingRight: matches == false ? "16px" : "",
          }}
        >
          <TextField
            id="username"
            name="Username"
            label="User name"
            value={loginform.Username}
            onChange={handleInputChange}
            error={errors.Username}
            variant="outlined"
            required
            fullWidth
          />
        </Grid>
        <br></br>
        <Grid
          item
          xs={12}
          sm={6}
          md={6}
          lg={4}
          style={{
            marginLeft: matches == false ? "16px" : "80px",
            paddingRight: matches == false ? "16px" : "",
          }}
        >
          <TextField
            type="password"
            id="password"
            name="Password"
            label="Password"
            value={loginform.Password}
            onChange={handleInputChange}
            error={errors.Password}
            variant="outlined"
            required
            fullWidth
          />
        </Grid>
        <Grid item xs={6} sm={3} md={2}>
          <button
            type="submit"
            className="btn"
            style={{
              marginLeft: matches == false ? "16px" : "80px",

              marginTop: "20px",
              marginBottom: "60px",
              backgroundColor: "#13607C",
              color: "white",
            }}
          //onClick={handleLogin}
          >
            Sign In
          </button>
        </Grid>
      </Grid>
    </form>
  );
}
